








































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import gitlabLogin from './gitlab/Login.vue';
import githubLogin from './github/Login.vue';
import GenericCheckbox from '../../generic/forms/Checkbox.vue';
import GenericButton from '../../generic/forms/Button.vue';
import Spinner from '../../generic/Spinner.vue';
import { getModule } from 'vuex-module-decorators';
import MainModule from '../../../store/modules/MainModule';
import LocalForage from '../../../helpers/LocalForage';
import { SignIn } from '../../../helpers/SignIn';
import { AuthenticatableSource, Credentials } from 'ganttlab-entities';
import { trackInteractionEvent } from '../../../helpers/GTM';

const mainState = getModule(MainModule);

@Component({
  components: {
    gitlabLogin,
    githubLogin,
    GenericCheckbox,
    GenericButton,
    Spinner,
  },
})
export default class Authenticate extends Vue {
  displayLoginComponent = false;
  authenticating = false;
  sourceGateway: AuthenticatableSource | null = null;

  private credentials: Credentials = {};

  @Prop(String) private source!: string;

  // adding convenient sign-in on Enter key
  windowKeyup(event: KeyboardEvent) {
    if (event.key && event.key === 'Enter') {
      this.doSignIn();
    }
  }
  created() {
    window.addEventListener('keyup', this.windowKeyup);
  }
  destroyed() {
    window.removeEventListener('keyup', this.windowKeyup);
  }

  async mounted() {
    this.$nextTick(() => {
      const mainStateCredentials = mainState.getSourceCredentials(this.source);
      if (mainStateCredentials) {
        // credentials are in vuex store? use those!
        for (const key in mainStateCredentials) {
          Vue.set(this.credentials, key, mainStateCredentials[key]);
        }
      }
      this.displayLoginComponent = true;
    });
  }

  get loginComponent() {
    return `${this.source}Login`;
  }

  @Watch('credentials', { deep: true })
  onSyncedCredentialsChanged(newCredentials: Credentials) {
    const sourcedCredential: {
      [key: string]: Credentials;
    } = {};
    sourcedCredential[this.source] = newCredentials;
    // save credentials in vuex upon change
    mainState.setCredentials(sourcedCredential);
  }

  // remember status is stored in vuex store
  get remember(): boolean {
    return mainState.remember;
  }
  set remember(remember: boolean) {
    mainState.setRemember(remember);
  }

  @Emit('set-step')
  setStep(step: number) {
    return step;
  }

  async doSignIn() {
    trackInteractionEvent(
      'Authentication',
      'With remember?',
      this.remember ? 'true' : 'false',
    );
    this.authenticating = true;
    this.$emit('signing-in', true);
    if (this.sourceGateway) {
      if (!(await SignIn(this.sourceGateway, this.credentials))) {
        this.$emit('signin-error', true);
      }
      LocalForage.setItem('remember', this.remember);
      if (this.remember) {
        await LocalForage.setItem(
          'source',
          this.sourceGateway ? this.sourceGateway.slug : null,
        );
        await LocalForage.setItem(
          'credentialsBySource',
          mainState.credentialsBySource,
        );
      } else {
        LocalForage.removeItem('source');
        LocalForage.removeItem('credentialsBySource');
        LocalForage.removeItem('viewsBySource');
      }
    }
    this.authenticating = false;
  }

  setSourceGateway(sourceGateway: AuthenticatableSource) {
    this.sourceGateway = sourceGateway;
  }
}
